<template>
  <Error v-if="store.error" :module="store.$id" />
  <v-select
    v-else
    :variant="!showLabel ? 'solo' : undefined"
    :density="!showLabel ? 'compact' : 'default'"
    label="Firma"
    hide-details
    class="mt-3 mb-2"
    v-model="internalValue"
    item-title="CustomerName"
    item-value="CustomerId"
    :items="useFilter
      ? store.data.filter(
        (customer) => settingsStore.sessionDatasLoaded[customer.CustomerId] &&
          settingsStore.sessionDatas[customer.CustomerId].Bediener.Typ !== 'Kunde'
      )
      : store.data"
    :loading="settingsStore.customersLoading"
    placeholder="--- Kunde wählen ---"
    :return-object="false"
  />
</template>

<script setup lang="ts">
import {useStorage} from '@/composables/storage';
import Error from './Error.vue';
import pinia from '@/plugins/pinia';
import {useCustomersStore} from '@/store/customers';
import {useSettings} from '@/store/settings';
import {computed} from 'vue';

const emits = defineEmits({
  'update:modelValue'(val: string | null) {
    return typeof val === 'number';
  },
});

const props = defineProps({
  showLabel: {
    type: Boolean,
    default: false,
  },
  useModel: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: String,
    default: useSettings(pinia).customerId,
  },
  useFilter: {
    type: Boolean,
    default: false,
  },
});

const settingsStore = useSettings();

const store = useCustomersStore();
useStorage(store);

const internalValue = computed({
  get() {
    if (props.useModel) {
      return props.modelValue;
    }
    return settingsStore.customerId;
  },
  set(newVal: string | null) {
    if (props.useModel) {
      emits('update:modelValue', newVal);
      return;
    }
    settingsStore.customerId = newVal;
  },
});

defineExpose({
  Error,
  internalValue,
  props,
  emits,
});
</script>
